var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"progressbar"},[_c('div',{staticClass:"bar",style:({ transform: `scaleX(${_vm.percentage / 100})`, '-ms-transform': `scaleX(${_vm.percentage / 100})` })})])
}
var staticRenderFns = []

export { render, staticRenderFns }